angular.module('controllers').controller('roleController', ['$scope', '$rootScope', '$controller', '$mdDialog', '$http', 'Crud', '$route', '$routeParams', '$location',
    function ($scope, $rootScope, $controller, $mdDialog, $http, Crud, $route, $routeParams, $location) {
        $rootScope.path = '/role';
        $rootScope.modelName = 'role';
        $scope.pathTemplate = 'users/roles';
        $scope.title = 'Roluri';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'id';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'asc';
        $scope.classAction = 'td-big';
        $scope.columns = {
            //'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
            'role_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
            'status':{'label':'Status', 'filter':1, 'filterType':'select'}
        };

        $scope.columns.status.options = [
            {'id':'', 'value' : ''},
            {'id':1, 'value' : 'true'},
            {'id':0, 'value' : 'false'}
        ];

        $scope.additionals = [];
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'role_name';

        var selected = [];
        $scope.checkedAll = [];
        $scope.toggleAll = function (keyObject, objects) {
            if($scope.checkedAll[keyObject] == true) {
                $scope.checkedAll[keyObject] = false;
                angular.forEach(objects, function (items, index) {
                    $scope.checked[items.id] = false;
                    selected.splice(selected.indexOf(items.id), 1);
                });
            } else {
                $scope.checkedAll[keyObject] = true;
                angular.forEach(objects, function (items, index) {
                    $scope.checked[items.id] = true;
                    selected.push(items.id);
                });
            }
            selected = selected.filter (function (value, index, array) {
                return array.indexOf (value) == index;
            });
            $scope.addPermissions();
        }

       $scope.checked = [];
        $scope.toggle = function (item, keyObject, object) {
            if($scope.checked[item] == true) {
                $scope.checked[item] = false;
                selected.splice(selected.indexOf(item), 1);
            } else {
                $scope.checked[item] = true;
                selected.push(item);
            }

            selected = selected.filter (function (value, index, array) {
                return array.indexOf (value) == index;
            });

            var allTrue = [];var no= 0;
            angular.forEach(object, function (items, key) {
                if($scope.checked[items.id] === true) {
                    allTrue[no] = key;
                    no++;
                }
            });
            if (allTrue.length >= 1 && allTrue.length == object.length) {
                $scope.checkedAll[keyObject] = true;
            } else {
                $scope.checkedAll[keyObject] = false;
            }

            $scope.addPermissions();
        };

        $scope.addPermissions = function () {
            $scope.additionals['invalid'] = '';
            var post = {};
            post['permissions'] = selected;
            post['roleId'] = $scope.modelData.id;
            post['route'] = 'addPermissions';

            Crud.post('form-urlencoded', post, $scope.path + '/addPermissions')
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    }
                    $scope.errors = {};

                })
                .error(function (data) {
                    $scope.errors = data.errors;
                });
        };

        /* detail model */
        $rootScope.detailPermission = function () {

            $scope.getPermissions = function (path, offset, per_page) {
                $scope.range = [];
                $scope.itemsPerPageOptions = [
                    {id: 1, name: '1'},
                    {id: 5, name: '5'},
                    {id: 10, name: '10'},
                    {id: 25, name: '25'},
                    {id: 50, name: '50'},
                    {id: 0, name: 'All'}
                ];

                $scope.state = {};
                if (angular.isUndefined(per_page)) {
                    if (!angular.isUndefined($scope.state.itemsPerPage)) {
                        per_page = $scope.state.itemsPerPage;
                    }
                } else {
                    $scope.state.itemsPerPage = per_page;
                }
                $scope.state.page = offset;
                if ($scope.state.page > $scope.no_pages) {
                    $scope.state.page = $scope.no_pages;
                    offset = $scope.no_pages;
                }
                if (per_page == 0) {
                    $scope.state.page = 1;
                    $scope.state.itemsPerPage = 0;
                }
                if (angular.isUndefined($scope.no_pages)) {
                    $scope.no_pages = 1;
                }
                $scope.isLoading = true;
                $scope.role_id = [];
                $scope.$watch('no_pages', function (item) {
                    item = $scope.no_pages;
                }, true);

                Crud.get(path +'/getPermissions?page='+ offset +'&per_page='+ per_page)
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            $scope.from = data.from;
                            $scope.to = data.to;
                            $scope.total = data.total;
                            $scope.no_pages = Math.ceil(data.total / data.per_page);

                            if (per_page == 0) {
                                $scope.range = [{}];
                            } else {
                                for (var i = 0; i < $scope.no_pages; i++) {
                                    $scope.range[i] = i;
                                }
                            }
                            $scope.models = data.data;
                            $scope.models.per_page = data.per_page;
                            $scope.models.current_page = data.current_page;
                            $scope.selected = {};
                            $scope.selectedAll = false;
                        }
                        $scope.isLoading = false;

                    });

            };
            $scope.getPermissions($scope.path, 1, $scope.defaultItem);


            Crud.show($routeParams.id, $scope.path)
                .success(function (data) {
                    $scope.modelData = data;
                    angular.forEach($scope.modelData.permissions, function (item, key) {
                        selected.push(item.id);
                        $scope.checked[item.id] = true;
                    });
                });
        };

    }]
)
